module.exports = __webpack_public_path__ + "media/img/about/main-banner-mobile-a7333a45dfe6b7efde84eb7f9a1136f8.webp";